import { KeyStatus } from '@/types/locker';

/** Nyckel på en tapp, så som modalen behöver den för att avgöra om den går att välja. */
export interface SelectableKeySlot {
  status?: string | null;
  keyNumber?: string | null;
  vehicleId?: string | null;
}

/**
 * Grön nyckel i skåpet, med OnPrem-tapp, som inte sitter på ett annat fordon.
 * Fordonets egen nyckel är valbar så kopplingen kan behållas.
 */
export function isKeySlotSelectable(
  key: SelectableKeySlot | null | undefined,
  vehicleId: string
): boolean {
  if (!key) return false;
  if (key.status !== KeyStatus.InCabinet) return false;
  if (!String(key.keyNumber ?? '').trim()) return false;
  const owner = key.vehicleId != null ? String(key.vehicleId).trim() : '';
  if (owner && owner !== String(vehicleId)) return false;
  return true;
}

/** MariaDB returnerar 1 eller NULL från EXISTS-underfrågan i fordonslistan. */
export function vehicleHasCabinetKey(value: unknown): boolean {
  return value === true || value === 1 || value === '1';
}
